// Const for docs that we are using

// Static API-Docs menu links
const staticDocsMenu = [
  // {
  //   id: 0,
  //   name: 'Docs Home',
  //   description: 'API Docs Home',
  //   link: '/apis/docs-home',
  //   type: 'content',
  //   subMenu: null,
  // },
  // {
  //   id: 1,
  //   name: 'Integration Checklist',
  //   description: 'Integration Checklist',
  //   type: 'content',
  //   link: '/apis/integration-checklist',
  //   subMenu: null,
  // },
  {
    id: 2,
    name: 'Authorization',
    description: 'Authorization',
    type: 'content',
    link: '/apis/authorization',
    apiname: 'authorization-api',
    repourl: 'pages/authorization-api',
    subMenu: null,
  },
  {
    id: 3,
    name: 'JSON Web Signature (JWS)',
    description: 'JSON Web Signature (JWS)',
    type: 'content',
    link: '/apis/json-web-signature',
    repourl: 'pages/json-web-signature',
    subMenu: null,
  },
  // {
  //   "id": 2,
  //   "name": "API Explorer",
  //   "description": "API Explorer",
  //   "type": "content",
  //   "link": "/apis/api-explorer",
  //   "subMenu": null
  // }
];

export { staticDocsMenu };
